module.exports = __webpack_public_path__ + "static/media/question-start.f18686f3.mp3";